// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 渠道（Channels）—— 基于渠道字段文档 ----------
const CHANNELS = [
  {
    code: "facebook",
    name: "Facebook",
    icon: "📘",
    color: "bg-blue-500",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: true, card: "OG", richMedia: "强" },
    standard_fields: ["utm_source", "utm_medium", "utm_campaign"],
    custom_fields: ["fb_app_id", "fb_redirect_uri", "quote", "hashtag"],
    enabled: true,
  },
  {
    code: "messenger",
    name: "Messenger",
    icon: "💬",
    color: "bg-blue-400",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG", richMedia: "强" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["app_id", "ref"],
    enabled: true,
  },
  {
    code: "twitter",
    name: "Twitter / X",
    icon: "𝕏",
    color: "bg-slate-900",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: "limited", card: "Twitter Card", richMedia: "中" },
    standard_fields: ["utm_source", "utm_medium", "utm_campaign"],
    custom_fields: ["card_type", "via", "hashtags"],
    enabled: true,
  },
  {
    code: "whatsapp",
    name: "WhatsApp",
    icon: "📱",
    color: "bg-green-500",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG", richMedia: "中" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["phone", "text"],
    enabled: true,
  },
  {
    code: "telegram",
    name: "Telegram",
    icon: "✈️",
    color: "bg-cyan-500",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG + TG", richMedia: "很强" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["text", "instant_view"],
    enabled: true,
  },
  {
    code: "line",
    name: "LINE",
    icon: "🟢",
    color: "bg-lime-500",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG", richMedia: "中" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["liff_id"],
    enabled: true,
  },
  {
    code: "kakao",
    name: "Kakao",
    icon: "🟡",
    color: "bg-yellow-500",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG + Kakao", richMedia: "强" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["app_key", "template_id"],
    enabled: false,
  },
  {
    code: "discord",
    name: "Discord",
    icon: "🎮",
    color: "bg-indigo-500",
    category: "messaging",
    category_name: "即时通讯",
    capabilities: { dm: true, group: true, card: "OG", richMedia: "强" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["webhook_url", "embed_color"],
    enabled: true,
  },
  {
    code: "instagram",
    name: "Instagram",
    icon: "📷",
    color: "bg-pink-500",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: false, card: "OG", richMedia: "强" },
    standard_fields: ["utm_source"],
    custom_fields: ["story_template"],
    enabled: false,
  },
  {
    code: "reddit",
    name: "Reddit",
    icon: "👽",
    color: "bg-orange-600",
    category: "community",
    category_name: "社区论坛",
    capabilities: { dm: false, group: true, card: "OG", richMedia: "中" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["subreddit", "flair"],
    enabled: true,
  },
  {
    code: "linkedin",
    name: "LinkedIn",
    icon: "💼",
    color: "bg-blue-700",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: false, card: "OG", richMedia: "中" },
    standard_fields: ["utm_source", "utm_medium"],
    custom_fields: ["share_via"],
    enabled: false,
  },
  {
    code: "tiktok",
    name: "TikTok",
    icon: "🎵",
    color: "bg-black",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: false, card: "OG", richMedia: "强" },
    standard_fields: ["utm_source"],
    custom_fields: ["client_key", "video_template"],
    enabled: false,
  },
  {
    code: "snapchat",
    name: "Snapchat",
    icon: "👻",
    color: "bg-yellow-400",
    category: "social",
    category_name: "社交网络",
    capabilities: { dm: true, group: false, card: "OG", richMedia: "中" },
    standard_fields: ["utm_source"],
    custom_fields: ["sticker_id"],
    enabled: false,
  },
];
// ---------- 用户列表 ----------
const USERS = [
  { id: "u_001", name: "李管理", email: "li.admin@easyshare.com", role: "sdk_admin", games: ["all"], lastActive: "2 分钟前", status: "active" },
  { id: "u_002", name: "张三", email: "zhang.san@kingsquest.com", role: "operator", games: ["g_001"], lastActive: "5 分钟前", status: "active" },
  { id: "u_003", name: "李四", email: "li.si@kingsquest.com", role: "operator", games: ["g_001", "g_002"], lastActive: "1 小时前", status: "active" },
  { id: "u_004", name: "王工", email: "wang.dev@kingsquest.com", role: "developer", games: ["g_001"], lastActive: "昨天", status: "active" },
  { id: "u_005", name: "Alice", email: "alice@matchhero.com", role: "operator", games: ["g_003"], lastActive: "3 天前", status: "active" },
  { id: "u_006", name: "Bob", email: "bob@matchhero.com", role: "developer", games: ["g_003"], lastActive: "1 周前", status: "inactive" },
];

// ---------- 操作日志 ----------
const AUDIT_LOGS = [
  { time: "2026-05-15 17:32:18", user: "张三", action: "更新分享配置", target: "王者征途 / NA-iOS", detail: "修改 Discord 渠道 UTM 参数" },
  { time: "2026-05-15 16:45:02", user: "李管理", action: "发布 SDK 版本", target: "Android v2.4.0", detail: "标记为推荐版本" },
  { time: "2026-05-15 14:22:51", user: "张三", action: "创建包体", target: "王者征途 / JP-iOS", detail: "Bundle ID: com.kingsquest.ios.jp" },
  { time: "2026-05-15 11:08:33", user: "李四", action: "导出数据", target: "梦幻西游 渠道对比", detail: "时间范围 最近 30 天，CSV 格式" },
  { time: "2026-05-14 18:54:12", user: "李管理", action: "调整系统参数", target: "归因窗口", detail: "默认归因窗口 7 天 → 14 天" },
];

export { CHANNELS, USERS, AUDIT_LOGS };
